$shm_service_dashboard $shm_service_workspace
	service_id \
	task_id \
	task_title? \
	mode \edit
	view_enabled false
	edit? null
	view? null
	Title $mol_string_button
		value? <=> task_title? \
	Mode $shm_service_mode_controls
		edit? <=> edit? null
		view? <=> view? null
		view_enabled <= view_enabled
		edit_color <= edit_color \
		view_color <= view_color \
	Menu $shm_service_task_menu
	edit_color \
	view_color \
